import React from 'react';
import styled from "styled-components";
import { StyledLink } from './index';
import { routeConstants } from "../constants/index";
import nykreditIcons from '../images/icons/Nykredit_Icons.svg';
import { useSelector } from "react-redux";
import logo from "../images/ps-logo.svg";


const Wrapper = styled.div`
    // -- STICKY -- //
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1;
    // -- /STICKY-- //

    width: 100%;
    height: 70px;
    background-color: #FFFFFF;
    padding: 0 20px; 
    display: ${props => (props.isModalActive ? 'none' : 'flex')};
    justify-content: space-between;

    //box-shadow: 0 0 15px rgb(42 42 42 / 15%);
    box-shadow: 0px 0px 40px rgba(42,42,42,0.1);

    ${props => props.theme.mediaQueries.medium}{
        height: 77px;
        margin-bottom: 3px;
        display: flex;
        justify-content: space-between;
        //border-bottom: 3px solid #F7F7F5;
    }
`

const Img = styled.img`
    width: 142px;
`

const Buttons = styled.div`
    text-align: center;
    display: flex;
    justify-content: space-between;
    align-items: center;

    ${props => props.theme.mediaQueries.medium}{
        
    };
`

const ButtonWrapper = styled.div`
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
        margin-left: 25px;


    ${props => props.theme.mediaQueries.medium}{
        display: flex;
        flex-direction: row;
        align-items: center;
        margin-left: 35px;
    }
`

const IconWrapper = styled.div`
    background-color: ${props => props.theme.buttonColor.default};
    border-radius: 50%;
    width: 30px;
    height: 30px;
    padding: 6px;
    
    ${props => props.theme.mediaQueries.medium}{
        padding: 5px;
    }
`

const HeaderInfoWrapper = styled.div`
    margin-left: auto;
    margin-right: auto;
    max-width: 961px;
    display: flex;
    justify-content: space-between;
    width: 100%;
`
const Icon = styled.svg`
    width: 18px;
    height: 18px;
    display: inline-block;
    background-image: url(${props => props.backgroundImg});
    background-repeat: no-repeat;
`

const P = styled.p`

    line-height: 20px;
    font-size: 0.83rem;

    ${props => props.theme.mediaQueries.medium}{
        margin-left: 10px;

        font-size: 0.7rem;
    };
` 

const Header = ({ type, onClick, text, name,  disabled}) => {
    const isModalActive = useSelector(state => state.globalStyleReducer.modal.active);

    return (
        <Wrapper 
        
            id="stickyHeader"
            isModalActive={isModalActive}
            type={type}
            onClick={onClick}
            name={name}
            disabled={false}
        >
            <HeaderInfoWrapper>
            <Img src={logo} title="Privatsikring" />

            <Buttons>
                <StyledLink
                    to={routeConstants.ContactModal}
                    reduxNextPage={routeConstants.BookMeetingModal}
                >
                    <ButtonWrapper>
                        <IconWrapper>
                        <Icon
                            backgroundImg={`${nykreditIcons}#Book`}
                        />
                        </IconWrapper>
                        <P>Book møde</P>
                    </ButtonWrapper>
                </StyledLink>
            </Buttons>
            </HeaderInfoWrapper>
        </Wrapper>
    )
}

export default Header;